export default __webpack_public_path__ + "ca9a6c0.png";